var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3134 0.562465H2.81335C2.37091 0.557962 1.94475 0.72916 1.62839 1.0385C1.31202 1.34783 1.13129 1.77003 1.12585 2.21246V21.7912C1.13228 22.233 1.31344 22.6542 1.6297 22.9628C1.94596 23.2713 2.37155 23.442 2.81335 23.4375H22.3134C22.7558 23.441 23.1817 23.2692 23.4979 22.9597C23.8141 22.6501 23.9949 22.228 24.0009 21.7856V2.20684C23.993 1.76571 23.8113 1.34552 23.4953 1.0376C23.1793 0.729686 22.7545 0.558935 22.3134 0.562465Z",
    fill: "#0076B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51149 9.13684H7.90711V20.0625H4.51149V9.13684ZM6.21024 3.69934C6.5997 3.69934 6.98041 3.81485 7.30421 4.03127C7.62801 4.24768 7.88035 4.55527 8.0293 4.91512C8.17826 5.27497 8.21714 5.67091 8.14102 6.05287C8.0649 6.43482 7.87721 6.78561 7.60169 7.06087C7.32617 7.33613 6.97519 7.52349 6.59317 7.59924C6.21115 7.67499 5.81524 7.63574 5.45553 7.48644C5.09582 7.33714 4.78847 7.08451 4.57237 6.76051C4.35627 6.4365 4.24112 6.05568 4.24149 5.66622C4.24198 5.1444 4.44962 4.64412 4.81878 4.27531C5.18794 3.9065 5.68842 3.69934 6.21024 3.69934ZM10.0371 9.13684H13.2921V10.6368H13.3371C13.7909 9.77809 14.8971 8.87247 16.549 8.87247C19.9877 8.86497 20.6252 11.1281 20.6252 14.0625V20.0625H17.2296V14.7468C17.2296 13.4812 17.2071 11.8518 15.4652 11.8518C13.7234 11.8518 13.4271 13.2318 13.4271 14.6643V20.0625H10.0371V9.13684Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.fdc736d7ceb094db5643e441eab7e052.svg";
export { ForwardRef as ReactComponent };